import OneSignal from "react-onesignal";

export async function runOneSignal() {
	await OneSignal.init({
		appId: import.meta.env.VITE_ONESIGNAL_APP_ID,
		allowLocalhostAsSecureOrigin: import.meta.env.DEV,
	});
	OneSignal.Slidedown.promptPush();
}
